import { render, staticRenderFns } from "./generalframe.vue?vue&type=template&id=0fa79cdd&scoped=true&"
import script from "./generalframe.vue?vue&type=script&lang=js&"
export * from "./generalframe.vue?vue&type=script&lang=js&"
import style0 from "./generalframe.vue?vue&type=style&index=0&id=0fa79cdd&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa79cdd",
  null
  
)

export default component.exports